import gql from 'graphql-tag';

export default gql`
    mutation ReplaceImageForALoad($input: ReplaceImageForALoadInput) {
        replaceImageForALoad(input: $input) {
            errors
        }
    }
`;
